module.exports = function (message) {
  if (typeof console !== 'undefined' && console.warn) {
    console.warn(message);
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/helpers/warning.js
 ** module id = 17
 ** module chunks = 0
 **/